// extracted by mini-css-extract-plugin
export default {"terms-and-conditions-container":"TermsAndConditions_terms-and-conditions-container__ht616","terms-and-conditions-details":"TermsAndConditions_terms-and-conditions-details__D1C0c"};